import React, { useState } from 'react';
import { Input, Button, Modal, Form, DatePicker } from 'antd';
import { FileOutlined } from '@ant-design/icons';
import moment from 'moment';

import { useDocuments } from './context';

export const useModalSearchFile = () => {
    // Manejo de los estados del componente
    const [find, setFind] = useState({ visible: false, loading: false });
    return {
        search: { ...find, set: setFind },
    }
};

export const ModalSearchFile = () => {
    
    // Hook para el control de los formularios
    const [form] = Form.useForm();

    const { folders, search } = useDocuments();
    const { current } = folders;

    const onSearch = async values => {

        search.set({ visible: true, loading: true });

        // La carpeta se resuelve completa al abrirla, asi que las filas ya
        // traen nombre y fecha. El filtro sigue en memoria y con la misma
        // semantica: Firestore no puede filtrar por carpeta con el schema
        // actual (files/{id}.folder apunta al doc-puntero, no a la carpeta).
        const todasLasFilas = await folders.list.ensureAllNames();

        // Los archivos viven en `rows` (datos); se convierten a items solo para
        // mostrar el resultado filtrado en el mismo List. Se usa el retorno de
        // ensureAllNames, no folders.list.rows: tras el await ese closure esta
        // obsoleto.
        let items = (todasLasFilas || []).map(folders.list.fileItem);

        items = values?.file?.trim()?.length > 0
            ? items.filter(item => item.data?.name === values.file)
            : items;

        items = values?.date
            ? items.filter(item => {
                const d = item?.data?.date_of_upload;
                const m = d?.toDate ? moment(d.toDate()) : (d instanceof Date ? moment(d) : null);
                return m ? m.isBetween(values.date, values.date, 'date', '[]') : false;
              })
            : items;

        // El resultado del filtro se pinta en `source`, que es lo que el List
        // renderiza sin pasar por la hidratacion por pagina. Updater para no
        // meter en el estado las funciones que `list` expone.
        folders.list.set(prev => ({ ...prev, rows: [], source: items }));
        form.resetFields();
        search.set({ visible: false, loading: false });

    };

    const todosHandle = () => {
        form.resetFields();
        folders.load( folders.routes.data[folders.routes.data.length -1]?.reference ).then( () => {
            search.set({ visible: false, loading: false });
            current.isUpload.set(true);
        });
    };

    const onSubmit = () => form.submit();
    const onCancel = () => search.set({ visible: false, loading: false });


    return search.visible ? (
        <Modal
            forceRender
            visible = { search.visible }
            confirmLoading = { search.loading }
            title = 'Buscar archivos' 
            maskClosable = { false }
            closable = { false }
            footer = {[
                <Button style = {{ marginRight: 10 }} key = "cancel" onClick = { onCancel } > Cancelar </Button>,
                <Button.Group key = 'group' >
                <Button type = "primary" key = "clean" onClick = { todosHandle } > Todos </Button>
                <Button type = "primary" key = "search" onClick = { onSubmit } > Filtrar </Button>
                </Button.Group>
            ]} >
            <Form layout = "vertical" form = { form } onFinish = { onSearch } >
                <Form.Item name = "file" label = "Archivo" >
                    <Input
                        placeholder = "Nombre del archivo"
                        prefix = { <FileOutlined style = {{ color: 'rgba(0,0,0,.25)' }} /> } />
                    </Form.Item>
                    <Form.Item name = "date" label = "Fecha" >
                    <DatePicker  style={{ width: '65%', marginLeft: '3%' }} />
                </Form.Item>
            </Form>
        </Modal>
    ) : false
}